import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Routes from "./routes/Routes";
import {socket} from "api";
import queryClient from "api/query";
import {init} from "api/loader";
import useGoogleMapsLoader from "Hooks/useGoogleMapsLoader";
import { QueryClientProvider } from 'react-query';

// import "./App.css";
require("analytics");
function App() {
	React.useEffect(()=>{
		init();
	},[]);
	useGoogleMapsLoader();
	return (
		<QueryClientProvider client={queryClient}>
			<Router>
				<Switch>
					<Routes />
				</Switch>
			</Router>
		</QueryClientProvider>
	);
}

export default App;
